<template>
    <div class="wrap-show-advance-info-box style-1" :id="id">
        <h3 class="title-box">{{ section }}</h3>
        <div v-if="banner" class="wrap-top-banner banner-effect-2">
            <a :href="href" class="link-banner">
            <figure><img :src="banner" width="1170" height="240" :alt="section"></figure>
            </a>
        </div>
        <div class="wrap-products" >
            <div class="tab-contents col-md-12">
                <div class="tab-content-item active" id="tool_1a">
                    <Carousel
                    :perPageCustom="[[320,1],[360,1],[375,1],[768,3],[1024,3],[1200,5]]"
                    :loop="true" 
                    :autoplay="true"
                    :autoplayTimeout="8000"
                    :autoplayHoverPause="true"
                    :navigationEnabled="true"
                    :paginationEnabled="false"
                    navigationNextLabel=">"
                    navigationPrevLabel="<"
                    >
                        <slide v-for="(item, index) in products" :key="index">
                            <Product :product="item"></Product>
                        </slide>
                    </Carousel>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { Carousel, Slide } from 'vue-carousel';
import Product from '../../Product.vue'


export default {
    name: 'ProductsWithBanner',
    props: [
        'section',
        'banner',
        'products',
        'id',
        'href',
        'responsive'
    ],
    components: {
        Product,
        Carousel,
        Slide        
    }
}
</script>
<style scoped>
@import url('style.css');
</style>
